import React from 'react';
import { FiAlertCircle, FiAlertTriangle, FiInfo, FiCheckCircle } from 'react-icons/fi';
import './ParentAlertCard.css';

const severityConfig = {
  urgent: { icon: FiAlertCircle, color: '#ef4444', bg: 'rgba(239, 68, 68, 0.06)', label: 'Urgent' },
  important: { icon: FiAlertTriangle, color: '#f59e0b', bg: 'rgba(245, 158, 11, 0.06)', label: 'Important' },
  watch: { icon: FiInfo, color: '#3b82f6', bg: 'rgba(59, 130, 246, 0.06)', label: 'Watch' },
  informational: { icon: FiCheckCircle, color: '#22c55e', bg: 'rgba(34, 197, 94, 0.06)', label: 'Informational' },
};

function ParentAlertCard({ alert, onMarkReviewed, onViewDetails }) {
  const config = severityConfig[alert.severity] || severityConfig.informational;
  const Icon = config.icon;

  return (
    <div className="parent-alert-card" style={{ borderLeftColor: config.color }}>
      <div className="parent-alert-card__header">
        <div className="parent-alert-card__severity" style={{ color: config.color, background: config.bg }}>
          <Icon size={14} />
          <span>{config.label}</span>
        </div>
        <span className="parent-alert-card__course">{alert.course}</span>
        <span className="parent-alert-card__date">{alert.date}</span>
      </div>

      <p className="parent-alert-card__description">{alert.description}</p>

      {alert.suggestedResponse && (
        <p className="parent-alert-card__suggestion">
          <strong>Suggestion:</strong> {alert.suggestedResponse}
        </p>
      )}

      <div className="parent-alert-card__actions">
        {alert.status === 'new' && onMarkReviewed && (
          <button
            className="parent-alert-card__action parent-alert-card__action--secondary"
            onClick={() => onMarkReviewed(alert.id)}
          >
            Mark as Reviewed
          </button>
        )}
        {onViewDetails && (
          <button
            className="parent-alert-card__action parent-alert-card__action--primary"
            onClick={() => onViewDetails(alert)}
          >
            View Details
          </button>
        )}
      </div>
    </div>
  );
}

export default ParentAlertCard;
